import { Configuration, SettingsApi } from '@sr-sdks/api-sdk-axios';
import { queryOptions } from '@tanstack/react-query';
import { configuration } from '../../configuration';
import axiosInstance, { bypassCacheConfig } from '../../utils/axiosInstance';
import { toApiError } from '../../utils/httpError';

const settingsQueryKeys = {
  all: ['settings'] as const,
  features: () => [...settingsQueryKeys.all, 'features'] as const,
};

const getSettingsApi = () => {
  return new SettingsApi(
    new Configuration(),
    configuration.SHARED_API_BASE,
    axiosInstance,
  );
};

/**
 * Fetch all feature flags
 */
export const fetchFeatures = async (): Promise<Record<string, string>> => {
  try {
    const response =
      await getSettingsApi().settingControllerFindAllFeatures(
        bypassCacheConfig(),
      );

    return (response.data as unknown) as Record<string, string>;
  } catch (error) {
    // Do NOT capture Sentry exceptions here; QueryCache.onError already captures.
    throw toApiError(error, {
      endpoint: 'settingControllerFindAllFeatures',
    });
  }
};

/**
 * Get all feature flags.
 */
export const queryOptionsGetFeatures = () => {
  return queryOptions({
    queryFn: () => fetchFeatures(),
    queryKey: settingsQueryKeys.features(),
  });
};
